export class LoadVideos {
  static readonly type = '[HowTo] LoadVideos';
}
